import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import EditorialList from './EditorialList';
import EditorialEditor from './EditorialEditor';
import CityList from './CityList';
import CityEditor from './CityEditor';
import LocationList from './LocationList';

/**
 * ContentRoutes — sub-router for /content/*
 * Handles editorial, city guide, and location management routes.
 */
export default function ContentRoutes() {
  return (
    <Routes>
      {/* Default: redirect to editorials list */}
      <Route index element={<Navigate to="editorials" replace />} />

      {/* Editorials */}
      <Route path="editorials" element={<EditorialList />} />
      <Route path="editorials/new" element={<EditorialEditor />} />
      <Route path="editorials/:slug" element={<EditorialEditor />} />

      {/* City Guides */}
      <Route path="cities" element={<CityList />} />
      <Route path="cities/:slug" element={<CityEditor />} />
      <Route path="cities/:slug/locations" element={<LocationList />} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="editorials" replace />} />
    </Routes>
  );
}
